import { castEnumForDisplay } from "../../helpers/enumHelpers";
import { UserStatus } from "../enums/UserStatus";
import { BranchStatus } from "../enums/BranchStatus";
import { AcademicYearStatus } from "../enums/AcademicYearStatus";
import { TimetableStatus } from "../enums/TimetableStatus";
import { TransactionType } from "../enums/TransactionType";
import { PaymentMethod } from "../enums/PaymentMethod";
import { PaymentDirection } from "../enums/PaymentDirection";
import { EnrollmentStatus } from "../enums/EnrollmentStatus";
import { AnnouncementAudience } from "../enums/AnnouncementAudience";
import { NewsletterAudience } from "../enums/NewsletterAudience";
import { NotificationStatus } from "../enums/NotificationStatus";
import { NotificationType } from "../enums/NotificationType";
import { NotificationChannel } from "../enums/NotificationChannel";
import { ActionType } from "../enums/ActionType";
import { EntityType } from "../enums/EntityType";
import { InventoryLogType } from "../enums/InventoryLogType";
import { PurchaseOrderStatus } from "../enums/PurchaseOrderStatus";
import { TransitionStatus } from "../enums/TransitionStatus";

const createEnumOptions = <T extends Record<string, string>>(enumObj: T) =>
  Object.values(enumObj).map((value) => ({
    value,
    label: castEnumForDisplay(value) ?? value,
  }));

export const USER_STATUS_OPTIONS = createEnumOptions(UserStatus);
export const BRANCH_STATUS_OPTIONS = createEnumOptions(BranchStatus);
export const ACADEMIC_YEAR_STATUS_OPTIONS =
  createEnumOptions(AcademicYearStatus);
export const TIMETABLE_STATUS_OPTIONS = createEnumOptions(TimetableStatus);
export const TRANSACTION_TYPE_OPTIONS = createEnumOptions(TransactionType);
export const PAYMENT_METHOD_OPTIONS = createEnumOptions(PaymentMethod);
export const PAYMENT_DIRECTION_OPTIONS = createEnumOptions(PaymentDirection);
export const ENROLLMENT_STATUS_OPTIONS = createEnumOptions(EnrollmentStatus);
export const ANNOUNCEMENT_AUDIENCE_OPTIONS =
  createEnumOptions(AnnouncementAudience);
export const NEWSLETTER_AUDIENCE_OPTIONS =
  createEnumOptions(NewsletterAudience);
export const NOTIFICATION_STATUS_OPTIONS =
  createEnumOptions(NotificationStatus);
export const NOTIFICATION_TYPE_OPTIONS = createEnumOptions(NotificationType);
export const NOTIFICATION_CHANNEL_OPTIONS =
  createEnumOptions(NotificationChannel);
export const ACTION_TYPE_OPTIONS = createEnumOptions(ActionType);
export const ENTITY_TYPE_OPTIONS = createEnumOptions(EntityType);
export const INVENTORY_LOG_TYPE_OPTIONS = createEnumOptions(InventoryLogType);
export const PURCHASE_ORDER_STATUS_OPTIONS =
  createEnumOptions(PurchaseOrderStatus);
export const TRANSITION_STATUS_OPTIONS = createEnumOptions(TransitionStatus);
